import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface OpenBoxAnimationControllerState {
  skipAnimation: boolean
}

const initialState: OpenBoxAnimationControllerState = {
  skipAnimation: false,
}

const openBoxAnimationControllerSlice = createSlice({
  name: 'openBoxAnimationController',
  initialState,
  reducers: {
    setSkipAnimation: (state, action: PayloadAction<boolean>) => {
      state.skipAnimation = action.payload
    },
    resetAnimationSettings: (state) => {
      state.skipAnimation = false
    },
  },
})

export const { setSkipAnimation, resetAnimationSettings } = openBoxAnimationControllerSlice.actions
export default openBoxAnimationControllerSlice.reducer
